import { useLang } from '@/i18n';
import EfImg from '@elem/ui/ef-img';
import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import IconA1 from './icons/IconA1';
import IconA2 from './icons/IconA2';
import IconA3 from './icons/IconA3';
import IconA4 from './icons/IconA4';
import IconA5 from './icons/IconA5';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('theProduct.SectionC');
    return (
        <div className={styles.TheComp}>
            <EfSpec />
            <EfSection hasAnimation={false} title={t('title')} desc={t('desc')} />

            <div className="ef-container SectionC-in">
                <div className="SectionC-list">
                    <div className="SectionC-item">
                        <IconA1 />
                        <div className="SectionC-item-text">{t('item1')}</div>
                    </div>
                    <div className="SectionC-item">
                        <IconA2 />
                        <div className="SectionC-item-text">{t('item2')}</div>
                    </div>
                    <div className="SectionC-item">
                        <IconA3 />
                        <div className="SectionC-item-text">{t('item3')}</div>
                    </div>
                    <div className="SectionC-item">
                        <IconA4 />
                        <div className="SectionC-item-text">{t('item4')}</div>
                    </div>
                    <div className="SectionC-item">
                        <IconA5 />
                        <div className="SectionC-item-text">{t('item5')}</div>
                    </div>
                </div>
                <div className="SectionC-img2">
                    <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1722858329684/aaa1.jpg" />
                </div>
            </div>
        </div>
    );
}
